<div class="row">
    <div class="col-sm-6">
        <div id="job-invites-filter-all-container" class="custom-checkbox" title="Search All filters">
            <label id="job-invites-filter-all-label" class="checkbox-label font-normal">
                <input id="job-invites-filter-all-checkbox" type="checkbox" [(ngModel)]="all" (change)="jobInvitesStatusFilter($event,'all')" />
                <span class="checkmark" style="top: -5px"></span>
                <p class="label-ppp"> All</p>
            </label>
        </div>
    </div>

    <div id="job-invites-filter-list-container" *ngIf="jobInvitesStatusList?.length > 0">
      <form id="job-invites-filter-form" [formGroup]="jobInvitesFilterForm">
          <div *ngFor="let item of jobInvitesStatusList; let i = index">
              <div class="col-sm-6">
                  <div id="job-invites-filter-item-{{i}}" class="custom-checkbox" title="Search {{item.value | titlecase}} filters">
                      <label id="job-invites-filter-label-{{item.itemId}}" class="checkbox-label font-normal">
                          <input id="job-invites-filter-checkbox-{{item.itemId}}" type="checkbox" formControlName="{{item.itemId}}"
                              (change)="jobInvitesStatusFilter($event,item.itemId)" />
                          <span class="checkmark" style="top: -5px"></span>
                          <p *ngIf="item == 'INITIATED'" class="label-ppp"> Invited</p>
                          <p *ngIf="item == 'REJECTED'" class="label-ppp"> Rejected</p>
                          <p *ngIf="item == 'ACCEPTED'" class="label-ppp"> Submitted</p>
                          <p *ngIf="
                          item != 'ACCEPTED'
                          && item != 'INITIATED'
                          && item != 'REJECTED'" class="label-ppp"> {{item.value | titlecase}}</p>
                      </label>
                  </div>
              </div>
          </div>
      </form>
    </div>

</div>
